import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Logout",
  "use": "Logout-usage",
  "viewBox": "0 0 34 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 36\" id=\"Logout\"><path fill-rule=\"evenodd\" d=\"M11.938 4.176v4.216c-4.31 1.935-7.313 6.265-7.313 11.296 0 6.834 5.54 12.375 12.375 12.375s12.375-5.541 12.375-12.376c0-5.03-3.002-9.36-7.313-11.295V4.176c6.531 2.13 11.25 8.27 11.25 15.511C33.313 28.697 26.01 36 17 36 7.99 36 .687 28.697.687 19.687c0-7.241 4.72-13.381 11.25-15.511zM14.75.562h3.938v11.25H14.75V.563z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol